export interface ISubtractable<T> {
  start: number;
  end:   number;

  clone(start: number, end: number): T;
}

// immutable subtract function (expects start === end for contiguous pieces)
export function subtract<T extends ISubtractable<T>>(entries: T[], entry: T) {
  const results: T[] = [];
  for (const e of entries) {
    if ((entry.start >= e.end) || (entry.end <= e.start)) {
      results.push(e);
      continue;
    }

    if (entry.start > e.start) {
      if (entry.end < e.end) {
        results.push(e.clone(entry.end, e.end));
      }
      e.end = entry.start;
      results.push(e);
    } else if (entry.end < e.end) {
      if (entry.end > e.start) {
        e.start = entry.end;
        results.push(e);
      }
    }
  }
  return results;
}
